import type { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../../services/authService";
import { getEffectiveAccess } from "../../services/authSessionService";
import {
  adminRolesFromAccess,
  canShowContractsModule,
  canShowPrizeRulesModule,
} from "../../utils/sessionModuleAccess";

type PermissionRouteProps = {
  readonly children: ReactElement;
  readonly requireContractsModule?: boolean;
  readonly requirePrizeRulesModule?: boolean;
};

export const PermissionRoute = ({
  children,
  requireContractsModule = false,
  requirePrizeRulesModule = false,
}: PermissionRouteProps) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const effectiveAccess = getEffectiveAccess();
  const adminRoles = adminRolesFromAccess(effectiveAccess);

  if (requireContractsModule && !canShowContractsModule(effectiveAccess, adminRoles)) {
    return <Navigate to="/" replace />;
  }

  if (requirePrizeRulesModule && !canShowPrizeRulesModule(effectiveAccess, adminRoles)) {
    return <Navigate to="/" replace />;
  }

  return children;
};
